import React from "react";
import * as XLSX from "xlsx";
import excelIcon from "../../img/whiteexcel.png";
import moment from "moment";

const ExportReport = ({
  exportData = [],
  labelHeader = [],
  exportHeading = [],
  sheetName = "",
}) => {
  const handleExport = () => {
    if (!exportData || exportData.length === 0) return;

    // const headers = exportHeading.length > 0 ? exportHeading : labelHeader;
    const headers = exportHeading.length > 1 ? exportHeading : labelHeader;

    if (!headers || headers.length === 0) return;

    const formattedData = exportData.map((item) => {
      const row = {};
      headers.forEach((header, index) => {
        row[header] = item[`col${index + 1}`];
      });
      return row;
    });

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();

    // const sheetName = headers[0] || "Sheet1";
    // XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    let finalSheetName = sheetName || headers[0] || "Sheet1";
    // Sanitize sheet name: remove restricted characters : \ / ? * [ ]
    finalSheetName = finalSheetName
      .replace(/[:\\/?\*\[\]]/g, "")
      .substring(0, 31);

    XLSX.utils.book_append_sheet(workbook, worksheet, finalSheetName);

    // const fileName = `${sheetName}(${moment().format("DD-MM-YYYYThh:mm:ss")})`;
    const fileName = `${finalSheetName}(${moment().format("DD-MM-YYYYThh:mm:ss")})`;

    XLSX.writeFile(workbook, `${fileName}.xlsx`);
  };

  return (
    <div
      className="pl-2 cousor_pointer"
      id="exportDataList"
      onClick={handleExport}
      style={{ cursor: "pointer" }}
    >
      <img src={excelIcon} alt="Export" />
    </div>
  );
};

export default ExportReport;
